import React from 'react';
import styles from './Checkbox.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

const CheckIcon = () => (
  <svg
    className={styles.check}
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    <polyline
      points="3 7 6 10 11 4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Checkbox = React.forwardRef(function Checkbox(
  {
    checked,
    onChange,
    disabled = false,
    tone = 'light',
    size = 'md',
    children,
    className,
    ...rest
  },
  ref
) {
  return (
    <label
      className={clsx(
        styles.wrapper,
        styles[size],
        tone === 'dark' && styles.onDark,
        disabled && styles.disabled,
        className
      )}
    >
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange?.(e)}
        disabled={disabled}
        className={styles.input}
        {...rest}
      />
      <span className={styles.box} aria-hidden="true">
        <CheckIcon />
      </span>
      {children && <span className={styles.label}>{children}</span>}
    </label>
  );
});

export default Checkbox;
